import { render, staticRenderFns } from "./TaskMessageIframe.vue?vue&type=template&id=0e8782d6&"
import script from "./TaskMessageIframe.vue?vue&type=script&lang=ts&"
export * from "./TaskMessageIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports